import { useSyncExternalStore } from 'react';

/**
 * The desktop/phone split is a real layout fork, not a set of responsive
 * utilities: a dense eight-column table is unusable at 375px however cleverly
 * it is squeezed, so the board renders a different component instead. That
 * decision has to be made in JS, which is what this is for.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const media = window.matchMedia(query);
      media.addEventListener('change', onChange);
      return () => {
        media.removeEventListener('change', onChange);
      };
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Tailwind's `md` breakpoint. Below this the console is a phone. */
export function useIsCompact(): boolean {
  return !useMediaQuery('(min-width: 768px)');
}
